(() => {
  document.querySelectorAll('[data-ww-announcement-row]').forEach((row) => {
    const button = row.parentElement.querySelector('[data-ww-announcement-pause]');
    const mobile = matchMedia('(max-width:749px)');
    const reduced = matchMedia('(prefers-reduced-motion:reduce)');
    let paused = reduced.matches;
    let touched = false;
    const update = () => {
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      button.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
    };
    button.addEventListener('click', () => { paused = !paused; update(); });
    row.addEventListener('touchstart', () => { touched = true; }, { passive: true });
    row.addEventListener('touchend', () => { touched = false; }, { passive: true });
    setInterval(() => {
      if (!mobile.matches || row.dataset.rotate !== 'true' || paused || touched || document.hidden || row.contains(document.activeElement)) return;
      const width = row.clientWidth;
      const index = Math.round(row.scrollLeft / width);
      row.scrollTo({ left: ((index + 1) % row.children.length) * width, behavior: reduced.matches ? 'instant' : 'smooth' });
    }, Math.max(3, Number(row.dataset.speed) || 5) * 1000);
    update();
  });
})();
